import React from "react";
import { styled } from "@mui/material/styles";
import entry_door from "../assets/entry_door.jpeg";
import kitchen from "../assets/kitchen.jpeg";
import dinning_area from "../assets/dinning_area.jpeg";
import living_room from "../assets/living_room.jpeg";
import master from "../assets/master_2.jpeg";
import master_bath from "../assets/master_bath.jpeg";
import room_2 from "../assets/room_2.jpeg";
import room_3 from "../assets/room_3.jpeg";

import yard from "../assets/yard.jpeg";
import outside_dining from "../assets/outside_dining.jpeg";
import fire_pit from "../assets/fire_pit.jpeg";
import river_2 from "../assets/river_2.jpeg";
import shed_room from "../assets/shed_room.jpeg";
import winter from "../assets/winter.jpeg";

import Item from "./carousel/item";
import { buttonBg } from "../constants/colors";

const CarouselContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  overflowX: "scroll",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "honeydew",
  height: "100%",
  width: "100%",
  padding: "24px",
});

const Header = styled("h2")({
  fontFamily: "Roboto Slab",
  fontWeight: "600",
  marginTop: "30px",
  marginBottom: "40px",
  fontSize: "3rem",
  marginLeft: "10px",
  color: buttonBg,
});

const items_outside = [
  {
    img: yard,
    title: "Outside area",
    desc: "Multiple hammocks overlooking the river with a long grass yard",
    alt: "",
  },
  {
    img: outside_dining,
    title: "Outside dining",
    desc: "Gas grill",
    alt: "",
  },
  {
    img: fire_pit,
    title: "Relax by the river",
    desc: "",
    alt: "",
  },
  {
    img: river_2,
    title: "River",
    desc: "",
    alt: "",
  },
  {
    img: shed_room,
    title: "Detached Woodsy Unit",
    desc: "",
    alt: "",
  },
  {
    img: winter,
    title: "Winter wonderland",
    desc: "",
    alt: "",
  },
];

const items_inside = [
  {
    img: entry_door,
    title: "Entry door",
    desc: "",
    alt: "",
  },
  {
    img: kitchen,
    title: "Kitchen",
    desc: "Recently remodled and fully stocked for the cooking enthusiast",
    alt: "",
  },
  {
    img: dinning_area,
    title: "Dinning Area",
    desc: "Large dining table",
    alt: "",
  },
  {
    img: living_room, 
    title: "Living room", 
    desc: "",
    alt: "",
  },
  {
    img: master,
    title: "Master Bedroom",
    desc: "King bed",
    alt: "",
  },
  {
    img: master_bath,
    title: "Master Bathroom",
    desc: "",
    alt: "",
  },
  {
    img: room_2,
    title: "Queen bed", 
    desc: "",
    alt: "",
  },
  {
    img: room_3,
    title: "Bunk ",
    desc: "3 twin and 1 full bed",
    alt: "",
  },
  
];

const Carousel = () => {
  return (
    <Container id={"property"}>
      <Header>Property</Header>
      <CarouselContainer>
        {items_inside.map(({ img, title, desc, alt }, index) => (
          <Item
            key={`${index}-carosuel`}
            alt={alt}
            img={img}
            title={title}
            desc={desc}
          />
        ))}
      </CarouselContainer>
      <CarouselContainer>
        {items_outside.map(({ img, title, desc, alt }, index) => (
          <Item
            key={`${index}-carosuel`}
            alt={alt}
            img={img}
            title={title}
            desc={desc}
          />
        ))}
      </CarouselContainer>
    </Container>
  );
};

export default Carousel;
